import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Typography from '@segment/matcha/components/Typography';
export var SubTitle = /*#__PURE__*/_styled(Typography, true ? {
  target: "elm17wd0"
} : {
  target: "elm17wd0",
  label: "SubTitle"
})(true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQWNjb3JkaW9uL1N1YlRpdGxlL1N1YlRpdGxlLnZpZXdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU0wQyIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL0FjY29yZGlvbi9TdWJUaXRsZS9TdWJUaXRsZS52aWV3cy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5pbXBvcnQgVHlwb2dyYXBoeSBmcm9tICdAc2VnbWVudC9tYXRjaGEvY29tcG9uZW50cy9UeXBvZ3JhcGh5J1xuaW1wb3J0IHR5cGUgeyBUeXBvZ3JhcGh5UHJvcHMgfSBmcm9tICdAc2VnbWVudC9tYXRjaGEvY29tcG9uZW50cy9UeXBvZ3JhcGh5L1R5cG9ncmFwaHkudmlld3MnXG5cbmV4cG9ydCB0eXBlIFN1YlRpdGxlVG9rZW5zID0gVHlwb2dyYXBoeVByb3BzXG5leHBvcnQgY29uc3QgU3ViVGl0bGUgPSBzdHlsZWQoVHlwb2dyYXBoeSlgXG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIG1hcmdpbjogMTZweCAwO1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});